export default __webpack_public_path__ + "static/media/vessel.e33f2de1.png";